import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Modal,
  Form,
  Spin,
  InputNumber,
  Button,
  DatePicker,
  Divider,
  notification,
} from "antd";
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";

import moment from "moment";
import { useAuth } from "../../context/auth";

const ActionModal = ({ visible, onCancel, onOk, modalType, editRecord }) => {
  const { accessToken } = useAuth();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!editRecord) return;

    if (modalType === 'new') form.resetFields();
    if (modalType === 'edit') form.setFieldsValue({
      ...editRecord,
      validFrom: moment(editRecord.validFrom),
    });
  }, [editRecord, modalType, form]);

  const save = async (values) => {
    setLoading(true);

    const url = new URL(modalType === 'new' ? '/api/point' : '/api/point/' + editRecord.id, window.location);

    const res = await fetch(url, {
      method: modalType === 'new' ? 'POST' : 'PATCH',
      headers: {
        'X-ACCESS-TOKEN': accessToken,
        'content-type': 'application/json',
      },
      body: JSON.stringify(values),
    });
    if (res.ok) {
      notification["success"]({
        message: "Successfully saved data.",
      });
      onOk();
    } else {
      notification["error"]({
        message: "Something went wrong !",
        description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
      });
    }

    setLoading(false);
  };

  return (
    <>
      <Modal
        open={visible}
        title={
          modalType === "new" ? (
            <div className="flex items-center">
              <PlusOutlined />
              <span>New Point Setup</span>
            </div>
          ) : (
            <div className="flex items-center space-x-4">
              <EditOutlined />
              <span>Edit Point Setup</span>
            </div>
          )
        }
        width={window.innerWidth <= 1000 ? "95%" : "35%"}
        onCancel={onCancel}
        footer={
          <div className="w-full text-center mb-4 flex justify-center">
            <Button
              className="w-36"
              type="primary"
              ghost
              key="cancel"
              shape="round"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              onClick={() => form.validateFields().then(save)}
              className="w-36"
              key="save"
              type="primary"
              shape="round"
              loading={loading}
            >
              Save
            </Button>
          </div>
        }
      >
        <Spin spinning={loading} tip="Loading...">
          <Form
            form={form}
            onFinish={save}
            name="charger-management"
            layout="vertical"
          >
            <Row>
              <Col lg="5" className="ml-6">
                <Form.Item
                  label="Expenses (THB)"
                  colon={false}
                  name="fromBaht"
                  rules={[
                    {
                      required: true,
                      message: "Expenses is required.",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    allowClear
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    maxLength={7}
                    precision={2}
                    min={0}
                  />
                </Form.Item>
              </Col>
              <Col lg="1">
                <Form.Item
                  label=" "
                  colon={false}
                  style={{ textAlign: "center" }}
                >
                  =
                </Form.Item>
              </Col>
              <Col lg="5">
                <Form.Item
                  label="Get Green Point (Points)"
                  colon={false}
                  name="toPoint"
                  rules={[
                    {
                      required: true,
                      message: "Get Green Point is required.",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    allowClear
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    maxLength={7}
                    precision={2}
                    min={0}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider className="mt-1" />

            <Row>
              <Col lg="5" className="ml-6">
                <Form.Item
                  label="Green Point (Points)"
                  colon={false}
                  name="fromPoint"
                  rules={[
                    {
                      required: true,
                      message: "Green Point is required.",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    maxLength={7}
                    precision={2}
                    min={0}
                  />
                </Form.Item>
              </Col>
              <Col lg="1">
                <Form.Item
                  label=" "
                  colon={false}
                  style={{ textAlign: "center" }}
                >
                  =
                </Form.Item>
              </Col>
              <Col lg="5">
                <Form.Item
                  label="Redeem (THB)"
                  colon={false}
                  name="toBaht"
                  rules={[
                    {
                      required: true,
                      message: "Redeem is required.",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    maxLength={7}
                    precision={2}
                    min={0}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Divider className="mt-1" />

            <Row>
              <Col lg="5" className="ml-6">
                <Form.Item
                  label="Effective Date Form"
                  colon={false}
                  name="validFrom"
                  rules={[
                    {
                      required: true,
                      message: "Effective Date Form is required.",
                    },
                  ]}
                >
                  <DatePicker
                    showTime
                    disabledDate={(current) => current < moment()}
                    className="w-full"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default ActionModal;
